import { render, staticRenderFns } from "./CitasPaciente.vue?vue&type=template&id=fb17b750&scoped=true"
import script from "./CitasPaciente.vue?vue&type=script&lang=js"
export * from "./CitasPaciente.vue?vue&type=script&lang=js"
import style0 from "./CitasPaciente.vue?vue&type=style&index=0&id=fb17b750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/msuarez/PycharmProjects/terrada-front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb17b750",
  null
  
)

export default component.exports